
import React from 'react';
import './Plasticstorag.css';
import Plasticstora from '../../../imgs/Plasticstora.webp';

const Plasticstorag = () => {
  return (
    <div className='container'>
          <div className="Plasticsto-container">
      
      <div className="Plasticsto-imag">
        <img src={Plasticstora} alt="LED Bulb Injection Molding Machine" />
      </div>

      <div className="Plasticsto-text">
        <h2>Plastic Storage Box Making Machine</h2>
        <p>Single Cavity Mold For 18 Litre Storage Box</p>
      </div>
      
    </div>
    </div>
     
  );
};

export default Plasticstorag;

